import { render, staticRenderFns } from "./detailCustomer.vue?vue&type=template&id=4e4df7ac&scoped=true&"
import script from "./detailCustomer.vue?vue&type=script&lang=js&"
export * from "./detailCustomer.vue?vue&type=script&lang=js&"
import style0 from "./detailCustomer.vue?vue&type=style&index=0&id=4e4df7ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4df7ac",
  null
  
)

export default component.exports